/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { contentsRequestControllerCreate } from '../fn/contents-request/contents-request-controller-create';
import { ContentsRequestControllerCreate$Params } from '../fn/contents-request/contents-request-controller-create';
import { contentsRequestControllerDelete } from '../fn/contents-request/contents-request-controller-delete';
import { ContentsRequestControllerDelete$Params } from '../fn/contents-request/contents-request-controller-delete';
import { contentsRequestControllerFindAll } from '../fn/contents-request/contents-request-controller-find-all';
import { ContentsRequestControllerFindAll$Params } from '../fn/contents-request/contents-request-controller-find-all';
import { contentsRequestControllerFindById } from '../fn/contents-request/contents-request-controller-find-by-id';
import { ContentsRequestControllerFindById$Params } from '../fn/contents-request/contents-request-controller-find-by-id';
import { contentsRequestControllerGetCount } from '../fn/contents-request/contents-request-controller-get-count';
import { ContentsRequestControllerGetCount$Params } from '../fn/contents-request/contents-request-controller-get-count';
import { contentsRequestControllerGetPendingCount } from '../fn/contents-request/contents-request-controller-get-pending-count';
import { ContentsRequestControllerGetPendingCount$Params } from '../fn/contents-request/contents-request-controller-get-pending-count';
import { contentsRequestControllerGetStat } from '../fn/contents-request/contents-request-controller-get-stat';
import { ContentsRequestControllerGetStat$Params } from '../fn/contents-request/contents-request-controller-get-stat';
import { contentsRequestControllerSearchCursor } from '../fn/contents-request/contents-request-controller-search-cursor';
import { ContentsRequestControllerSearchCursor$Params } from '../fn/contents-request/contents-request-controller-search-cursor';
import { contentsRequestControllerSearchOffset } from '../fn/contents-request/contents-request-controller-search-offset';
import { ContentsRequestControllerSearchOffset$Params } from '../fn/contents-request/contents-request-controller-search-offset';
import { contentsRequestControllerStatusUpdate } from '../fn/contents-request/contents-request-controller-status-update';
import { ContentsRequestControllerStatusUpdate$Params } from '../fn/contents-request/contents-request-controller-status-update';
import { contentsRequestControllerUpdate } from '../fn/contents-request/contents-request-controller-update';
import { ContentsRequestControllerUpdate$Params } from '../fn/contents-request/contents-request-controller-update';
import { ContentsRequestCountDto } from '../models/contents-request-count-dto';
import { ContentsRequestDto } from '../models/contents-request-dto';
import { ContentsRequestStatDto } from '../models/contents-request-stat-dto';
import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class ContentsRequestService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `contentsRequestControllerFindAll()` */
  static readonly ContentsRequestControllerFindAllPath = '/api/contents-request';

  /**
   * 콘텐츠 제작 의뢰 전체 조회.
   *
   * 콘텐츠 제작 의뢰 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestControllerFindAll$Response(params?: ContentsRequestControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContentsRequestDto>>> {
    return contentsRequestControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 제작 의뢰 전체 조회.
   *
   * 콘텐츠 제작 의뢰 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestControllerFindAll(params?: ContentsRequestControllerFindAll$Params, context?: HttpContext): Observable<Array<ContentsRequestDto>> {
    return this.contentsRequestControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ContentsRequestDto>>): Array<ContentsRequestDto> => r.body)
    );
  }

  /** Path part for operation `contentsRequestControllerCreate()` */
  static readonly ContentsRequestControllerCreatePath = '/api/contents-request';

  /**
   * 콘텐츠 제작 의뢰 생성.
   *
   * 콘텐츠 제작 의뢰를 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contentsRequestControllerCreate$Response(params: ContentsRequestControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestDto>> {
    return contentsRequestControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 제작 의뢰 생성.
   *
   * 콘텐츠 제작 의뢰를 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contentsRequestControllerCreate(params: ContentsRequestControllerCreate$Params, context?: HttpContext): Observable<ContentsRequestDto> {
    return this.contentsRequestControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentsRequestDto>): ContentsRequestDto => r.body)
    );
  }

  /** Path part for operation `contentsRequestControllerGetPendingCount()` */
  static readonly ContentsRequestControllerGetPendingCountPath = '/api/contents-request/pending-count';

  /**
   * 대기 중인 콘텐츠 의뢰 수 조회.
   *
   * 대기 중인 콘텐츠 의뢰 수를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestControllerGetPendingCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestControllerGetPendingCount$Response(params?: ContentsRequestControllerGetPendingCount$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return contentsRequestControllerGetPendingCount(this.http, this.rootUrl, params, context);
  }

  /**
   * 대기 중인 콘텐츠 의뢰 수 조회.
   *
   * 대기 중인 콘텐츠 의뢰 수를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestControllerGetPendingCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestControllerGetPendingCount(params?: ContentsRequestControllerGetPendingCount$Params, context?: HttpContext): Observable<number> {
    return this.contentsRequestControllerGetPendingCount$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `contentsRequestControllerGetStat()` */
  static readonly ContentsRequestControllerGetStatPath = '/api/contents-request/stat';

  /**
   * 콘텐츠 제작 의뢰 통계 조회.
   *
   * 콘텐츠 제작 의뢰 통계를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestControllerGetStat()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestControllerGetStat$Response(params: ContentsRequestControllerGetStat$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestStatDto>> {
    return contentsRequestControllerGetStat(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 제작 의뢰 통계 조회.
   *
   * 콘텐츠 제작 의뢰 통계를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestControllerGetStat$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestControllerGetStat(params: ContentsRequestControllerGetStat$Params, context?: HttpContext): Observable<ContentsRequestStatDto> {
    return this.contentsRequestControllerGetStat$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentsRequestStatDto>): ContentsRequestStatDto => r.body)
    );
  }

  /** Path part for operation `contentsRequestControllerGetCount()` */
  static readonly ContentsRequestControllerGetCountPath = '/api/contents-request/count';

  /**
   * 콘텐츠 제작 의뢰 통계 조회.
   *
   * 콘텐츠 제작 의뢰 통계를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestControllerGetCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestControllerGetCount$Response(params?: ContentsRequestControllerGetCount$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestCountDto>> {
    return contentsRequestControllerGetCount(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 제작 의뢰 통계 조회.
   *
   * 콘텐츠 제작 의뢰 통계를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestControllerGetCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestControllerGetCount(params?: ContentsRequestControllerGetCount$Params, context?: HttpContext): Observable<ContentsRequestCountDto> {
    return this.contentsRequestControllerGetCount$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentsRequestCountDto>): ContentsRequestCountDto => r.body)
    );
  }

  /** Path part for operation `contentsRequestControllerFindById()` */
  static readonly ContentsRequestControllerFindByIdPath = '/api/contents-request/{id}';

  /**
   * 콘텐츠 제작 의뢰 ID 기반 조회.
   *
   * 콘텐츠 제작 의뢰를 ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestControllerFindById$Response(params: ContentsRequestControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestDto>> {
    return contentsRequestControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 제작 의뢰 ID 기반 조회.
   *
   * 콘텐츠 제작 의뢰를 ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestControllerFindById(params: ContentsRequestControllerFindById$Params, context?: HttpContext): Observable<ContentsRequestDto> {
    return this.contentsRequestControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentsRequestDto>): ContentsRequestDto => r.body)
    );
  }

  /** Path part for operation `contentsRequestControllerSearchOffset()` */
  static readonly ContentsRequestControllerSearchOffsetPath = '/api/contents-request/search/offset';

  /**
   * 콘텐츠 제작 의뢰 오프셋 기반 조회.
   *
   * 콘텐츠 제작 의뢰를 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestControllerSearchOffset$Response(params: ContentsRequestControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return contentsRequestControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 제작 의뢰 오프셋 기반 조회.
   *
   * 콘텐츠 제작 의뢰를 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestControllerSearchOffset(params: ContentsRequestControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.contentsRequestControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `contentsRequestControllerSearchCursor()` */
  static readonly ContentsRequestControllerSearchCursorPath = '/api/contents-request/search/cursor';

  /**
   * 콘텐츠 제작 의뢰 커서 기반 조회.
   *
   * 콘텐츠 제작 의뢰를 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestControllerSearchCursor$Response(params: ContentsRequestControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return contentsRequestControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 제작 의뢰 커서 기반 조회.
   *
   * 콘텐츠 제작 의뢰를 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestControllerSearchCursor(params: ContentsRequestControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.contentsRequestControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `contentsRequestControllerStatusUpdate()` */
  static readonly ContentsRequestControllerStatusUpdatePath = '/api/contents-request/{id}/status';

  /**
   * 콘텐츠 제작 의뢰 상태 변경.
   *
   * 콘텐츠 제작 의뢰 상태를 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestControllerStatusUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contentsRequestControllerStatusUpdate$Response(params: ContentsRequestControllerStatusUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestDto>> {
    return contentsRequestControllerStatusUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 제작 의뢰 상태 변경.
   *
   * 콘텐츠 제작 의뢰 상태를 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestControllerStatusUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contentsRequestControllerStatusUpdate(params: ContentsRequestControllerStatusUpdate$Params, context?: HttpContext): Observable<ContentsRequestDto> {
    return this.contentsRequestControllerStatusUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentsRequestDto>): ContentsRequestDto => r.body)
    );
  }

  /** Path part for operation `contentsRequestControllerUpdate()` */
  static readonly ContentsRequestControllerUpdatePath = '/api/contents-request/{contentsRequestId}/{clientWorkspaceId}';

  /**
   * 콘텐츠 제작 의뢰 수정.
   *
   * 콘텐츠 제작 의뢰를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contentsRequestControllerUpdate$Response(params: ContentsRequestControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestDto>> {
    return contentsRequestControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 제작 의뢰 수정.
   *
   * 콘텐츠 제작 의뢰를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contentsRequestControllerUpdate(params: ContentsRequestControllerUpdate$Params, context?: HttpContext): Observable<ContentsRequestDto> {
    return this.contentsRequestControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentsRequestDto>): ContentsRequestDto => r.body)
    );
  }

  /** Path part for operation `contentsRequestControllerDelete()` */
  static readonly ContentsRequestControllerDeletePath = '/api/contents-request/{clientWorkspaceId}/{contentsRequestId}';

  /**
   * 콘텐츠 제작 의뢰 삭제.
   *
   * 콘텐츠 제작 의뢰를 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestControllerDelete$Response(params: ContentsRequestControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestDto>> {
    return contentsRequestControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 제작 의뢰 삭제.
   *
   * 콘텐츠 제작 의뢰를 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestControllerDelete(params: ContentsRequestControllerDelete$Params, context?: HttpContext): Observable<ContentsRequestDto> {
    return this.contentsRequestControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentsRequestDto>): ContentsRequestDto => r.body)
    );
  }

}
